import { Menu } from '../models/menu.model';

export enum MenuItemsEnum {
	ScanOutComponent = 10,
	DateManagementComponent = 20,
	PocketResetValidationComponent = 30,
	PartialInventoryComponent = 40
}

export const menuItems = [
	new Menu(
		MenuItemsEnum.ScanOutComponent,
		`Initial Scan Out`,
		'/scan-out',
		null,
		'find_in_page',
		null,
		null,
		false,
		0
	),
	new Menu(
		MenuItemsEnum.DateManagementComponent,
		`Date Management`,
		'/date-management',
		null,
		'event',
		null,
		null,
		false,
		0
	),
	new Menu(
		MenuItemsEnum.PocketResetValidationComponent,
		`Pkt Reset Validation`,
		'/pocket-reset',
		null,
		'manage_search',
		null,
		null,
		false,
		0
	),
	new Menu(
		MenuItemsEnum.PartialInventoryComponent,
		`Partial Inventory`,
		'/partial-inventory',
		null,
		'inventory_2',
		null,
		null,
		false,
		0
	)
];
